module.exports = "pegasus_template/assets/blocks/column-10-theme2.png";